<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="showAIOverlay"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="sm"
      class="position-relative p-4 bg-info"
      no-center
    >
      <template #overlay>
        <b-container>
          <pane-overlay-ai
            style="margin-top: 15px;"
            @close-button-click="handleCloseButtonClick"
          />
        </b-container>
      </template>
      <div>
        <h2>
          {{ settingsSessionObj ? `: ${settingsSessionObj.name}` : "" }}
        </h2>
        <b-tabs
          :pills="tabs.isPills"
          :small="tabs.isSmall"
          :justified="tabs.isJustified"
          :isFill="tabs.isFill"
          :end="tabs.isEnd"
          :vertical="tabs.isVertical"
          content-class="mt-3"
          defaultActiveKey="stage"
          nav-wrapper-class="sticky-top bg-light"
          card
        >
          <b-tab
            v-for="(aSection, index) in availSections"
            :key="index"
            :title="aSection.title"
          >
            <template #title>
              <h6 style="padding-top: 25px;">
                <b-icon
                  v-if="aSection.icon"
                  :icon="aSection.icon"
                  aria-hidden="true"
                />
                {{ aSection.title }}
              </h6>
            </template>
            <vue-custom-scrollbar
              class="scroll-area"
              :settings="settings"
              @ps-scroll-y="scrollHandle"
            >
              <component
                :is="aSection.component"
                v-bind="Object.assign({}, { ...propsData })"
                :ref="aSection.componentName"
                @video-recorded-info="handleSaveVideoInfo"
                @update-user-data="handleUpdateUserData"
              />
            </vue-custom-scrollbar>
          </b-tab>
        </b-tabs>
        <pane-restart-ice v-if="false" />
        <hr />
        <pane-rtc
          v-if="true"
          :resource="resource"
          :settings="settings"
          :user-data="userData"
          :root-path-collection="rootPathCollection"
          @update-user-data="handleUpdateUserData"
        />
        <hr />
        <resource-nav-bar
          v-if="resource"
          :resource="resource"
          @open-about="handleAboutClick"
        >
          <template v-slot:buttons-right>
            <b-button
              variant="outline-primary"
              size="md"
              class="my-2 my-md-0"
              @click="handleOpenExportModal('copy')"
              style="margin: 10px"
            >
              <b-icon icon="clipboard"></b-icon>
            </b-button>
            <b-button
              variant="outline-primary"
              size="md"
              class="my-2 my-md-0"
              :disabled="true"
              @click="handleOpenExportModal('print')"
              style="margin: 10px"
            >
              <b-icon icon="printer"></b-icon>
            </b-button>
            <b-button
              variant="outline-primary"
              size="md"
              class="my-2 my-md-0"
              @click="handleOpenExportModal('pdf')"
              style="margin: 10px"
            >
              <b-icon icon="cloud-download"></b-icon>
            </b-button>
            <b-button
              variant="outline-primary"
              size="md"
              class="my-2 my-md-0"
              @click="handleOpenExportModal('email')"
              style="margin: 10px"
            >
              <b-icon icon="envelope"></b-icon>
            </b-button>
          </template>
        </resource-nav-bar>
        <hr />
        <template v-if="true">
          <h2>
            <b-icon
              @click="handleToggleOverlayAI"
              icon="stars"
              class="border rounded p-2"
              style="cursor:pointer;"
            />
          </h2>
        </template>
        <pane-entry
          v-if="false"
          style="margin-top: 25px;"
          :ref="paneEntryRefId"
          :generating="generating"
          @generate-click="handleGenerateClick"
        />
        <pane-response
          v-if="false"
          style="margin-top: 25px;"
          :curr-doc="currDoc"
          :path="path"
          :profile="profile"
          :max-words="maxFilteredWords"
          :idx="currIdx"
          :output="currOutput"
          :is-generating="generating"
          @page-to="handlePageTo"
        />
        <export-modal
          :modal-id="exportModalId"
          :export-type-id="selectedExportTypeId"
          :curr-idx="currIdx"
          :outputs="outputsArr"
        />
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import ResourceNavBar from "@/components/blockResources/_components/resourceNavBar";
import firebase from "firebase";
import PaneIntro from "./paneIntro";
import PaneRtc from "./paneRTC";
import PaneRestartIce from "./paneRestartIce";
import PaneVideoCam from "./paneVideoCam";
import PaneEntry from "./paneEntry";
import PaneClips from "./paneClips";
import PaneLiveMonitors from "./paneLiveMonitors";
import PaneOverlayAi from "./paneOverlayAI";
import PaneResponse from "./paneResponse";
import ExportModal from "./exportModal";
import { mapGetters } from "vuex";
import VueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";

export default {
  name: "Display_Glance",
  mixins: [ResourceBlockDisplay],
  components: {
    PaneRtc,
    ResourceNavBar,
    PaneIntro,
    PaneOverlayAi,
    PaneEntry,
    PaneResponse,
    ExportModal,
    PaneRestartIce,
    VueCustomScrollbar
  },
  created() {
    this.checkProfile();
  },
  mounted() {
    if (this.profile && this.myAppId) {
      this.setUpSnapShot();
    }
  },
  props: {
    isDemo: {
      type: Boolean,
      required: false,
      default: false
    },
    pathPublishing: {
      type: String,
      default: null
    },
    appId: {
      type: String,
      default: "KS9fKKgQsw08alLuhC1O"
    }
  },
  computed: {
    ...mapGetters({
      profile: "user/profile"
    }),
    availSections() {
      return this.sections.filter(x => {
        return x.avail === true;
      });
    },
    propsData() {
      return {
        profile: this.profile,
        //provider: this.providerData,
        resource: this.resource,
        settings: this.settings,
        userData: this.userData,
        rootPathCollection: this.rootPathCollection,
        videos: this.glanceVideosOrdered
      };
    },
    rootPathCollection() {
      return this.profile &&
        this.profile.userId &&
        this.resource &&
        this.resource.toolId
        ? `users/${this.profile.userId}/lists/__apps/data/${this.resource.toolId}/cams`
        : null;
    },
    glanceVideosOrdered() {
      let _videos = this.glanceVideos;
      return _videos && Array.isArray(_videos)
        ? _videos.sort((a, b) => {
            if (
              a._created_at &&
              b._created_at &&
              a._created_at.seconds &&
              b._created_at.seconds
            ) {
              this.momentTest = a._created_at.seconds;
              return b._created_at.seconds - a._created_at.seconds;
            }
            return false;
          })
        : [];
    },
    filteredPollGroups() {
      return this.thePollGroups && Array.isArray(this.thePollGroups)
        ? this.thePollGroups.filter(theWord => {
            return (
              theWord.status &&
              theWord.status.state &&
              theWord.status.state == "COMPLETED"
            );
          })
        : [];
    },
    filteredWordsOrdered() {
      let _words = this.filteredPollGroups;
      return _words && Array.isArray(_words)
        ? _words.sort((a, b) => {
            if (
              a._created_at &&
              b._created_at &&
              a._created_at.seconds &&
              b._created_at.seconds
            ) {
              this.momentTest = a._created_at.seconds;
              return a._created_at.seconds - b._created_at.seconds;
            }
            return false;
          })
        : [];
    },
    maxFilteredWords() {
      return this.filteredWordsOrdered &&
        Array.isArray(this.filteredWordsOrdered) &&
        this.filteredWordsOrdered.length
        ? this.filteredWordsOrdered.length
        : 0;
    },
    userId() {
      return this.profile && this.profile.userId ? this.profile.userId : null;
    },
    firstname() {
      return this.profile && this.profile.firstname
        ? this.profile.firstname
        : null;
    },
    path() {
      if (!this.isDemo) {
        return this.userId && this.myAppId
          ? `/users/${this.userId}/lists/__apps/data/${this.myAppId}/ai_poll`
          : "";
      }
      return this.pathPublishing ? `${this.pathPublishing}/ai_poll` : "";
    },
    pathVideos() {
      if (!this.isDemo) {
        return this.userId && this.myAppId
          ? `/users/${this.userId}/lists/__apps/data/${this.myAppId}/videos`
          : "";
      }
      return this.pathPublishing ? `${this.pathPublishing}/videos` : "";
    },
    currDoc() {
      return this.filteredWordsOrdered &&
        Array.isArray(this.filteredWordsOrdered) &&
        this.filteredWordsOrdered.length > this.currIdx
        ? this.filteredWordsOrdered[this.currIdx]
        : null;
    },
    currOutput() {
      return this.currDoc && this.currDoc.output
        ? this.convertOutputToJSON(this.currDoc.output)
        : null;
    }
  },
  methods: {
    checkProfile() {
      if (this.profile) return;
      this.$store.dispatch("user/getProfile");
    },
    setUpSnapShot() {
      const db = firebase.firestore();

      if (this.pathVideos) {
        this.setUpSnapCollectionVideoRef(db);
      }
    },
    setUpSnapCollectionRef(db) {
      this.collectionRef = db.collection(this.path);
      this.unsub = this.collectionRef.onSnapshot(snapshot => {
        this.thePollGroups = [];
        snapshot.docs.forEach(doc => {
          this.thePollGroups.push({ ...doc.data(), id: doc.id });
        });
        if (this.isEntry) {
          this.currIdx =
            this.filteredWordsOrdered &&
            Array.isArray(this.filteredWordsOrdered)
              ? this.filteredWordsOrdered.length - 1
              : 0;
          this.isEntry = false;
        }
        //Check this that the current Payload

        if (this.currPayloadId) {
          //Handle teh processing of a submission
          let currentPayload = this.thePollGroups.filter(aPayload => {
            return aPayload.genId == this.currPayloadId;
          });

          if (currentPayload && Array.isArray(currentPayload)) {
            let thisPayLoad = currentPayload[0];
            if (thisPayLoad && thisPayLoad.status && thisPayLoad.status.state) {
              if (thisPayLoad.status.state == "PROCESSING") {
                this.generating = true;
              } else if (thisPayLoad.status.state == "COMPLETED") {
                //clear textbox
                let paneEntryComponent = this.$refs[this.paneEntryRefId];
                if (paneEntryComponent.hasOwnProperty("resetForm")) {
                  paneEntryComponent.resetForm();
                }
                //stop loading
                this.generating = false;

                //Move to last position- using the filtered
                this.currIdx =
                  this.filteredWordsOrdered &&
                  Array.isArray(this.filteredWordsOrdered)
                    ? this.filteredWordsOrdered.length - 1
                    : 0;

                //Clear Id
                this.currPayloadId = null;
              } else if (thisPayLoad.status.state == "ERRORED") {
                this.generating = false;
              }
            }
          }
        }
      });
    },
    setUpSnapCollectionVideoRef(db) {
      if (!this.unsubVideo) {
        this.collectionRef = db.collection(this.pathVideos);
        this.unsubVideo = this.collectionRef.onSnapshot(snapshot => {
          this.glanceVideos = [];
          snapshot.docs.forEach(doc => {
            this.glanceVideos.push({ ...doc.data(), id: doc.id });
          });
        });
      }
      /*
          if (this.isEntry) {
            this.currIdx = this.filteredWordsOrdered && Array.isArray(this.filteredWordsOrdered) ?
                this.filteredWordsOrdered.length - 1 : 0;
            this.isEntry = false;
          }
          //Check this that the current Payload

          if (this.currPayloadId) { //Handle teh processing of a submission
            let currentPayload = this.thePollGroups.filter((aPayload) => {
              return aPayload.genId == this.currPayloadId;
            });

            if (currentPayload && Array.isArray(currentPayload)) {
              let thisPayLoad = currentPayload[0];
              if (thisPayLoad && thisPayLoad.status && thisPayLoad.status.state) {
                if (thisPayLoad.status.state == 'PROCESSING') {
                  this.generating = true;
                } else if (thisPayLoad.status.state == 'COMPLETED') {
                  //clear textbox
                  let paneEntryComponent = this.$refs[this.paneEntryRefId];
                  if (paneEntryComponent.hasOwnProperty("resetForm")) {
                    paneEntryComponent.resetForm();
                  }
                  //stop loading
                  this.generating = false;

                  //Move to last position- using the filtered
                  this.currIdx = this.filteredWordsOrdered && Array.isArray(this.filteredWordsOrdered) ?
                      this.filteredWordsOrdered.length - 1 : 0;

                  //Clear Id
                  this.currPayloadId = null;
                } else if (thisPayLoad.status.state == 'ERRORED') {
                  this.generating = false;
                }
              }
            }
          }
        });
      }           */
    },
    handleGenerateClick(entryInput) {
      this.generateEntry(entryInput.replace(/(^"|"$)/g, ""));
    },
    generateEntry(entryInput) {
      let profileBy = this.profileBy();
      this.currPayloadId = `gen_${Date.now()}`;

      let payload = {
        genId: this.currPayloadId,
        _created_at: new Date(),
        _created_by: profileBy,
        subject: entryInput
      };

      this.collectionRef.add(payload); // Include values for { unspecified parameter } fields

      this.generating = true;
    },
    handleResetForm() {
      this.input = "";
    },
    scrollHandle(evt) {
      console.log(evt);
    },
    profileBy() {
      return {
        uid: this.profile && this.profile.userId ? this.profile.userId : null,
        name: this.profile
          ? `${this.profile.firstname} ${this.profile.lastname}`
          : null,
        imgURL: this.profile ? this.profile.imgURL : null
      };
    },
    convertOutputToJSON(responseOutput) {
      let output = {};

      if (responseOutput) {
        try {
          output = responseOutput.replace(/(\r\n|\n|\r)/gm, "");
          output = JSON.parse(output);
        } catch (e) {
          console.error(e); // error in the above string (in this case, yes)!
        }
      }
      return output;
    },
    handlePageTo(pageNumber) {
      this.currIdx = pageNumber;
    },
    handleOpenExportModal(exportTypeId) {
      this.selectedExportTypeId = exportTypeId;
      this.outputsArr = this.createArrayOfOutputs();
      this.$bvModal.show(this.exportModalId);
    },
    createArrayOfOutputs() {
      let outputsArr = [];
      this.filteredWordsOrdered.forEach(aWordsDoc => {
        outputsArr.push(this.convertOutputToJSON(aWordsDoc.output));
      });
      return outputsArr;
    },
    handleSaveVideoInfo(videoInfo) {
      let profileBy = this.profileBy();

      let payload = {
        _created_at: new Date(),
        _created_by: profileBy,
        deviceName: "Bedroom",
        video: videoInfo
      };

      this.collectionRef.add(payload); // Include values for { unspecified parameter } fields

      this.generating = true;
    },
    handleToggleOverlayAI() {
      this.showAIOverlay = !this.showAIOverlay;
    },
    handleCloseButtonClick() {
      this.showAIOverlay = false;
    }
  },
  watch: {
    path(newValue, oldValue) {
      //temp- may take out
      if (newValue) {
        this.setUpSnapShot();
      }
    },
    filteredPollGroups(newValue, oldValue) {
      //temp- may take out
      if (newValue) {
        //this.currIdx = newValue && Array.isArray(newValue) ? newValue.length - 1  : 0;
      }
    }
  },
  data() {
    return {
      variant: "dark",
      opacity: "0.85",
      blur: "2px",
      showAIOverlay: false,
      unsub: null,
      unsubVideo: null,
      isEntry: true,
      currIdx: 0,
      currPayloadId: null,
      exportModalId: "export-modal-id",
      selectedExportTypeId: null, //email|pdf|printer
      outputsArr: [],
      input: "",
      myAppId:
        this.resource && this.resource.toolId ? this.resource.toolId : null,
      collectionRef: null,
      collectionVideoRef: null,
      thePollGroups: [],
      glanceVideos: [],
      generating: false,
      paneEntryRefId: "pane-entry",
      tabs: {
        isPills: false,
        isSmall: true,
        isJustified: true,
        isFill: true,
        isEnd: false,
        isVertical: true
      },
      tab: {
        titleLinkAttributes: {
          color: "#5695e0"
        },
        hexColorTabBg: "#777",
        hexColorTabText: "#777",
        hexColorScreen: "#777"
      },
      sections: [
        {
          id: "cam",
          title: "Camera",
          component: PaneVideoCam,
          componentName: "PaneVideoCam",
          avail: true
        },
        {
          id: "clips",
          title: "Clips",
          component: PaneClips,
          componentName: "PaneClips",
          avail: true
        },
        {
          id: "live",
          title: "Live Cam",
          component: PaneLiveMonitors,
          componentName: "PaneLiveMonitors",
          avail: true
        },
        {
          id: "sos",
          title: "SOS Contacts",
          component: PaneClips,
          componentName: "PaneClips",
          avail: true
        },
        {
          id: "ai",
          title: "Reports",
          component: PaneClips,
          componentName: "PaneClips",
          avail: true
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
